import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import Card from 'components/Card';
import {
  commandWorkspaceGrantPermission,
  commandWorkspaceCollaboratorSummary,
} from 'containers/ConnectionManager/actions';

import CollaboratorsSummaryProvider from 'Workspace/containers/CollaboratorsSummaryProvider';
import SharingDialog from 'Workspace/components/SharingDialog';
import { selectWorkspaceCollaborators } from 'Workspace/Admin/store/selectors';

import {
  WorkspaceCardContainer,
  WorkspaceCardHeader,
  WorkspaceCardTitle,
  WorkspaceCardContent,
} from './styles';

const WorkspaceCard = ({ id, name, onRevoke, theme }) => (
  <Card>
    <WorkspaceCardContainer>
      <WorkspaceCardHeader>
        <WorkspaceCardTitle>{name}</WorkspaceCardTitle>
      </WorkspaceCardHeader>
      <WorkspaceCardContent>
        <CollaboratorsSummaryProvider
          id={id}
          fetchCollaboratorsCommand={commandWorkspaceCollaboratorSummary}
          collaboratorsSelector={selectWorkspaceCollaborators}
          render={(collaborators) => (
            <SharingDialog
              avatarBorderColor={theme['color.surface']}
              sharedWith={collaborators}
              refId={id}
              hasStorageInPermissionGrant
              permissionGrantCommand={commandWorkspaceGrantPermission}
              handleDelete={onRevoke}
            />
          )}
        />
      </WorkspaceCardContent>
    </WorkspaceCardContainer>
  </Card>
);

WorkspaceCard.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  onRevoke: PropTypes.func,
  theme: PropTypes.object,
};

export default withTheme(WorkspaceCard);
